import {range} from "utils/DBUtils";
import React from 'react';
import {
    AgeGatingCodesToolTip,
    ApplyAgeTargetingToolTip,
    AgeTargetingCodesToolTip,
    ApplyAgeGatingToolTip,
    BlockedZipCodesToolTip,
    GenderedTargetsToolTip,
    SegmentsToolTip,
    StateFiltersToolTip,
    TargetZipCodesToolTip
} from "components/break/tooltips/break-campaign-targeting-tool-tips";
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    key: "breaksCampaignGating",
    showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored'),
    props: {
        headerKey: 'Break Gating'
    },
    fields: [
        {
            conditionalSection: true,
            name: "hasAgeGating",
            required: true,
            props: {
                labelKey: 'editbreak.targeting.has_age_gating',
                helpContent: <ApplyAgeGatingToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.has_age_gating'}/></IntlProvider>
            },

            fields: [
              {
                  type: 'number',
                  name: 'ageGate.min',

                  props: {
                      labelKey: 'editbreak.targeting.age_gate_min',
                      helpContent: <AgeGatingCodesToolTip/>,
                      helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.age_gate_min'}/></IntlProvider>
                  }
              },
              {
                  type: 'number',
                  name: 'ageGate.max',

                  props: {
                      labelKey: 'editbreak.targeting.age_gate_max',
                      helpContent: <AgeGatingCodesToolTip/>,
                    helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.age_gate_max'}/></IntlProvider>
                  }
              },
              {
                type: "contenteditable",
                name: "ageGateTitle",
          
                props: {
                  labelKey: "Age Gate - Title",
                },
              },
              {
                type: "contenteditable",
                name: "ageGateCopy",
          
                props: {
                  labelKey: "Age Gate - Copy",
                },
              },

              {
                type: "contenteditable",
                name: "ageGateFailedTitle",
          
                props: {
                  labelKey: "Age Gate Failed - Title",
                },
              },
              {
                type: "contenteditable",
                name: "ageGateFailedCopy",
          
                props: {
                  labelKey: "Age Gate Failed - Copy",
                },
              },

              {
                type: "text",
                name: "ageGateFailedButtonCopy",
          
                props: {
                  labelKey: "Age Gate Failed - Button Copy",
                },
              },

              {
                type: "text",
                name: "ageGateFailedButtonUrl",
          
                props: {
                  labelKey: "Age Gate Failed - Button Url",
                },
              },

              {
                type: "image",
                name: "ageGateBackgroundImageId",
                idFor: "ageGateBackgroundImage",
                required: false,
                props: {
                  labelKey: "Age Gate - Desktop Background Image (420px high)",
                  imageType: "custom",
                },
              },

              {
                type: "image",
                name: "ageGateMobileBackgroundImageId",
                idFor: "ageGateMobileBackgroundImage",
                required: false,
                props: {
                  labelKey: "Age Gate - Mobile Background Image",
                  imageType: "custom",
                },
              },


            ]
        },
        {
            type: 'hardcodedText',
            props: {
                heading: 'Yes/No Gate',
                text: 'Configure a modal that appears before the user enters the break. It can help to ensure that users are properly targeted by asking a question like "Do you shop at Walmart?" or "Do you have a cat?"',
            }
        },
        {
            conditionalSection: true,
            name: "hasYesNoGate",
            required: true,
            props: {
                labelKey: 'Has Yes/No Gate?',
                // helpContent: <ApplyAgeTargetingToolTip/>,
            },

            fields: [
                {
                    type: 'hardcodedText',
                    props: {
                      heading: 'Modal Settings',
                    }
                },
                {
                    type: "contenteditable",
                    name: "yesNoGateTitle",
                    required: true,
              
                    props: {
                      labelKey: "Yes/No Gate - Title",
                    },
                  },
                  {
                    type: "contenteditable",
                    name: "yesNoGateBodyCopy",
                    required: true,
              
                    props: {
                      labelKey: "Yes/No Gate - Body Copy",
                    },
                  },
                  {
                    type: "text",
                    name: "yesNoGateYesButtonCopy",
                    required: true,
              
                    props: {
                      labelKey: "'Yes' Button Copy",
                    },
                  },
    
                  {
                    type: "text",
                    name: "yesNoGateNoButtonCopy",
                    required: true,
              
                    props: {
                      labelKey: "'No' Button Copy",
                    },
                  },
                  {
                    type: "image",
                    name: "yesNoGateBackgroundImageId",
                    idFor: "yesNoGateBackgroundImage",
                    required: false,
                    props: {
                      labelKey: "Desktop Background Image (420px high)",
                      imageType: "custom",
                    },
                  },
    
                  {
                    type: "image",
                    name: "yesNoGateMobileBackgroundImageId",
                    idFor: "yesNoGateMobileBackgroundImage",
                    required: false,
                    props: {
                      labelKey: "Mobile Background Image",
                      imageType: "custom",
                    },
                  },        
                  {
                    type: 'hardcodedText',
                    props: {
                      heading: 'No Screen',
                    }
                  },
                  {
                    type: "text",
                    name: "yesNoGateNoUrl",
              
                    props: {
                      labelKey: "Optional Redirect URL",
                      helperText: "If you specify a URL here the user will be redirected if they click 'No'"
                    },
                  },
                  {
                    type: "contenteditable",
                    name: "yesNoGateNoScreenTitle",
              
                    props: {
                      labelKey: "No Screen - Title",
                    },
                  },
                  {
                    type: "contenteditable",
                    name: "yesNoGateNoScreenBodyCopy",
              
                    props: {
                      labelKey: "No Screen - Body Copy",
                    },
                  },
                  {
                    type: "text",
                    name: "yesNoGateNoScreenButtonCopy",
              
                    props: {
                      labelKey: "No Screen - Optional Button Copy",
                      helperText: "Include a button on the 'No' screen."
                    },
                  },
                  {
                    type: "text",
                    name: "yesNoGateNoScreenButtonUrl",
              
                    props: {
                      labelKey: "No Screen - Optional Button Url",
                      helperText: "Url for the no button"
                    },
                  },

                  {
                    type: "image",
                    name: "yesNoGateNoBackgroundImageId",
                    idFor: "yesNoGateNoBackgroundImage",
                    required: false,
                    props: {
                      labelKey: "No Screen - Desktop Background Image (420px high)",
                      imageType: "custom",
                    },
                  },
    
                  {
                    type: "image",
                    name: "yesNoGateNoMobileBackgroundImageId",
                    idFor: "yesNoGateNoMobileBackgroundImage",
                    required: false,
                    props: {
                      labelKey: "No Screen - Mobile Background Image",
                      imageType: "custom",
                    },
                  },
            ]
        },

    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksCampaignGating.js